import { createSlice } from "@reduxjs/toolkit";

export enum EXPORT_TYPE {
  SUMMARY_REPORT = "SUMMARY_REPORT",
  LEAVE_REPORT = "LEAVE_REPORT",
  COMPENSATORY_LEAVE_REPORT = "COMPENSATORY_LEAVE_REPORT",
  LATE_EARLY_REPORT = "LATE_EARLY_REPORT",
  CHECK_IN_OUT = "CHECK_IN_OUT",
  TIMEKEEPING_DETAIL = "TIMEKEEPING_DETAIL",
}

interface FormFilterInterface {
  type: EXPORT_TYPE;
  fromMonth: number;
  fromYear: number;
  toMonth: number;
  toYear: number;
  search: string;
  departmentLevel1Code: string;
  departmentLevel2Code: string;
  leaveReasonCode: string;
  positionCode: string;
  workingAreaCode: string;
  timekeepingType: string;
}

interface InitialState {
  filterInput: FormFilterInterface;
}

const initialState: InitialState = {
  filterInput: {
    search: "",
    departmentLevel1Code: "",
    departmentLevel2Code: "",
    leaveReasonCode: "",
    positionCode: "",
    workingAreaCode: "",
    timekeepingType: "",
    fromMonth: new Date().getMonth() + 1,
    fromYear: new Date().getFullYear(),
    toMonth: new Date().getMonth() + 1,
    toYear: new Date().getFullYear(),
    type: EXPORT_TYPE.CHECK_IN_OUT,
  },
};

const formFilterHrReportSlice = createSlice({
  name: "formFilterHrReport",
  initialState,
  reducers: {
    formFilterHrReportUpdate: (state, action) => {
      Object.assign(state.filterInput, action.payload);
    },
    resetFilter: (state) => {
      state.filterInput = {
        ...initialState.filterInput,
        type: state.filterInput.type,
      };
    },
    formFilterHrReportReset: () => {
      return { ...initialState };
    },
  },
});

export const {
  formFilterHrReportUpdate,
  formFilterHrReportReset,
  resetFilter,
} = formFilterHrReportSlice.actions;

export default formFilterHrReportSlice.reducer;
